import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form as FormikForm } from 'formik'
import * as Yup from 'yup'
import * as authentication from '../../../lib/authentication'
import * as forms from '../../../lib/forms'
import routes from '../../../config/routes'
import TextFieldFormik from '../../commons/Fields/TextFieldFormik'
import CheckboxFieldFormik from '../../commons/Fields/CheckboxFieldFormik'
import PasswordFieldFormik from '../../commons/Fields/PasswordFieldFormik'
import Button from '../../commons/Button/Button'
import Link from '../../commons/Link/Link'
import Text from '../../commons/Text/Text'
import ErrorMessages from '../../commons/Errors/ErrorMessages'
import styles from './login.module.scss'

export const EMAIL_FIELD_ID = 'EMAIL_FIELD_ID'
export const PASSWORD_FIELD_ID = 'PASSWORD_FIELD_ID'

export const RESET_PASSWORD_LINK_ID = 'RESET_PASSWORD_LINK_ID'
export const TERMS_LINK_ID = 'TERMS_LINK_ID'

export const INITIAL_VALUES = {
  email: '',
  password: '',
  remember: false
}

export const VALIDATION_MESSAGES = {
  email: {
    format: 'Email inválido',
    required: 'Email requerido'
  },
  password: {
    format: 'Senha requerido'
  }
}

export const EmailSchema = {
  email: Yup.string()
    .required(VALIDATION_MESSAGES.email.required)
    .email(VALIDATION_MESSAGES.email.format)
}

export const PasswordSchema = {
  password: Yup.string().required(VALIDATION_MESSAGES.password.format)
}

export const LoginSchema = Yup.object().shape({
  ...EmailSchema,
  ...PasswordSchema
})

const LoginForm = (props) => {
  const { handleSubmit, error } = props

  const newInitialValues = {
    ...INITIAL_VALUES,
    email: authentication.getEmailCache()
  }

  return (
    <Formik
      enableReinitialize
      initialValues={newInitialValues}
      validationSchema={LoginSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid, setErrors, values }) => {
        const disabled = isSubmitting || !isValid

        useEffect(() => {
          forms.applyGeneralError(error?.hasError, values, setErrors)
        }, [error?.hasError, isSubmitting])

        return (
          <FormikForm>
            <TextFieldFormik
              id={EMAIL_FIELD_ID}
              name="email"
              variation="borderless"
              label="Digite seu e-mail"
            />

            <CheckboxFieldFormik name="remember" label="Lembrar meu e-mail" />

            <PasswordFieldFormik
              id={PASSWORD_FIELD_ID}
              name="password"
              label="Digite sua senha"
            />

            <ErrorMessages error={error} />

            <div className={styles.containerButton}>
              <Link to={routes.root.path}>
                <Button
                  type="outlined_dark"
                  margin="8px 0 24px"
                  width="160px"
                  buttonType="button"
                  className={styles.linkButton}
                >
                  Voltar
                </Button>
              </Link>

              <Button
                className={styles.entryButton}
                type="secondary"
                margin="8px 0 24px"
                width="160px"
                id="ENTRAR"
                buttonType="submit"
                disabled={disabled}
              >
                Entrar
              </Button>
            </div>

            <Text
              size="xs"
              lineHeight="21px"
              color="gray"
              variation="dark"
              margin="13px 0 0"
            >
              Esqueceu sua senha?
              <Link
                id={RESET_PASSWORD_LINK_ID}
                underline
                margin="0 3px"
                to={routes.resetPasswordSentEmail.path}
              >
                redefinir
              </Link>
            </Text>
          </FormikForm>
        )
      }}
    </Formik>
  )
}

LoginForm.defaultProps = {
  handleSubmit: null,
  error: {
    hasError: false,
    messages: []
  }
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.shape({
    hasError: PropTypes.bool,
    messages: PropTypes.arrayOf(PropTypes.string)
  })
}

export default LoginForm
